import { createApp } from 'vue'
import { createPinia } from 'pinia';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import  { AJAXappinfo,appinit  } from "jh-app-utils";

import '../assets/icon/iconfont.css'
import './style.css';

import App from './App.vue'
import '@assets/index.css';
import router from '@/router';
import '@/permission';


// process.env.NODE_ENV === 'development'
console.log(process.env.NODE_ENV ,'process.env.NODE_ENV','setTimeout')
appinit(process.env.NODE_ENV === 'development' ? 'localhost':'production').then(() => {
        createApp(App)
        .use(Antd)
        .use(createPinia())
        .use(router)
        .mount('#app')
})

// AJAXappinfo().then(() => {
//         createApp(App)
//         .use(Antd)
//         .use(createPinia())
//         .use(router)
//         .mount('#app')
// })



